<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2b"><a id="page_4"></a>Acknowledgments</h2>
<p class="para1">I thank Donna Barnitz, my incredible assistant and friend of twenty years. Many of the quilts in this book were a collaboration of our team of two. In addition to patiently editing and formatting text and critiquing designs, color choices, and fabrics, sometimes vociferously, Donna makes the quilts sing with her beautiful and creative machine quilting. I appreciate her honesty when she lets me know in no uncertain terms that my choices for a particular design are less than wonderful or otherwise not to her liking. Our working style—that of longtime friends unafraid to disagree—is the best possible environment to inspire creativity.</p>
<p class="para">My quilting group of fifteen years, Designing Women, is an integral part of this book, and many of the members’ quilts appear on the pages of this book: Mary Chappelle, Cathy Combs, Patricia Drennan, Michele Hymel, Anita McSorley, and Lisa Stewart. Through our monthly meetings, we continued to explore new designs and techniques that became the body of work for this book.</p>
<p class="para">If it weren’t for Ann Silva, of Ann Silva’s Bernina Sewing Center in Albuquerque, New Mexico, I may not have followed this creative path. It was Ann who strongly encouraged my early teaching efforts and introduced me to the wonderful world of Bernina. I also thank Bernina of America for the ongoing support and for including me in the Bernina Artisans program.</p>
<p class="para">I thank my editor, Liz Aneloski, for her patience and guidance through this process, and C&amp;T Publishing for having confidence in this book.</p>
<p class="para">Finally, I thank my daughter, Christi Garber, and my sister, Ann Rhodes, who believe in me and encourage me to always strive for greater heights. I love you.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter01.vue?6cc55f23